// eslint-disable-next-line import/prefer-default-export
export const getLanguage = (state) => state.LanguageReducer.language;
